import { create } from "zustand";

export type UserRole = "ADMIN" | "EMPLOYEE";

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  role: UserRole;
  employeeId: string | null;
}

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  isInitializing: boolean; // true while we attempt silent refresh on app load
  setSession: (user: AuthUser, accessToken: string) => void;
  clearSession: () => void;
  setInitializing: (value: boolean) => void;
}

/**
 * Access token is kept in memory only (never localStorage) to reduce XSS
 * exposure — the refresh token lives in an httpOnly cookie set by the
 * server and isn't reachable from JS at all. On full page reload, the app
 * calls /auth/refresh once (see api/axios.ts) to silently restore the
 * session before rendering protected routes.
 */
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isInitializing: true,
  setSession: (user, accessToken) => set({ user, accessToken, isAuthenticated: true }),
  clearSession: () => set({ user: null, accessToken: null, isAuthenticated: false }),
  setInitializing: (value) => set({ isInitializing: value }),
}));
